import { format, formatDistanceStrict, isAfter, parseISO } from 'date-fns';

/**
 * Human-readable expiry for an install link, e.g. "Expires Oct 6, 2026, 1:00 PM (in 7 days)".
 * `now` is injectable so the relative part is testable.
 */
export const formatLinkExpiry = (expiresAt: string, now: Date = new Date()): string => {
  const expiry = parseISO(expiresAt);
  const absolute = format(expiry, 'MMM d, yyyy, h:mm a');

  if (!isAfter(expiry, now)) {
    return `Expired ${absolute}`;
  }

  return `Expires ${absolute} (${formatDistanceStrict(expiry, now, { addSuffix: true })})`;
};
